export default __webpack_public_path__ + "static/media/image.enterprise-business-intelligence-private-limited.f1fe0572.png";